import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { NsContent } from 'components/common/ns-content/NsContent';
import { NsRadioInput } from 'components/common/ns-radio-input/NsRadioInput';
import { NsList } from 'components/common/ns-list/NsList';

import { selectHasPsr, setHasPsr } from 'state/psr/psr-slice';

import { stringToBool } from 'utils/misc';

export const testId = 'psrConsentTestId';

export const PsrConsent = () => {
  const dispatch = useDispatch();
  const hasPsr = useSelector(selectHasPsr, shallowEqual);

  const handleRadioChange = (event) => {
    const {
      target: { value }
    } = event;
    dispatch(setHasPsr(stringToBool(value)));
  };

  return (
    <NsContent spacing="loose" data-testid={testId}>
      <NsRadioInput
        className="inline"
        name="psrConsent"
        dataTestId="radioPsrEntryTestId"
        heading="Does anyone in your home need extra support with your energy supply?"
        helper="What kind of help we can offer"
        tipDetail={
          <>
            <p>
              <strong>Who we can help</strong>
            </p>
            <p>
              You may be eligible for extra support if you or someone in your
              household has a health condition, mobility, cognitive, sensory, or
              communication impairment, or is under 6 or of pensionable age.
            </p>
            <p>
              <strong>
                The Priority Services Register (PSR) helps energy and water
                companies support those who need extra help.
              </strong>
            </p>
            <p>
              <strong>Your energy supplier</strong>
            </p>
            <NsList>
              {[
                `Free gas safety checks`,
                `Help reading your meter`,
                `Free meter relocation`
              ]}
            </NsList>
            <p>
              <strong>Network operator</strong>
            </p>
            <NsList>
              {[
                `Advanced notice of planned power cuts`,
                `Heating and cooking facilities`,
                `Temporary accommodation`
              ]}
            </NsList>
            <p>
              <strong>Water company</strong>
            </p>
            <NsList>
              {[
                `Warning of water supply interruptions`,
                `Moving your water meter`,
                `Literature in accessible formats`
              ]}
            </NsList>
          </>
        }
        onChange={handleRadioChange}
        value={hasPsr}
        options={[
          {
            label: 'Yes',
            value: 'true'
          },
          {
            label: 'No',
            value: 'false'
          }
        ]}
      />
    </NsContent>
  );
};

export default PsrConsent;
